import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Config from '../../commons/config/Config.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import Loading from '../ui/Loading.js'
import swal from 'sweetalert'
import QRCode from 'qrcode'
import { FormattedMessage, injectIntl } from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';

class TwoFATotpSetup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            formData: { code: '' },
            redirectTo: null,
            loading: true,
            provisioningUri: null,
            qrImageUrl: null,
            manualSecret: null,
            recoveryCodes: [],
            codesAcknowledged: false,
            errors: [],
        };
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleConfirmSubmit = this.handleConfirmSubmit.bind(this);
        this.loginRandom = null;
    }

    getBrandedLogo(defaultFilename, visibilityConfigKey) {
        if (visibilityConfigKey && ConfigBusiness.get(visibilityConfigKey) === "false") return null;
        var slug = ConfigBusiness.get("generales.clienteSlug");
        if (slug && slug !== "false" && slug !== "default") return process.env.PUBLIC_URL + "/images/branding/" + slug + "/" + defaultFilename;
        return process.env.PUBLIC_URL + "/images/company/" + defaultFilename;
    }

    componentWillMount() {
        if (!localStorage.getItem("persona")) {
            this.setState({ redirectTo: '/' });
        }
        this.formValidation = new FormValidation({
            component: this, validators: { 'formData.code': function(value) { return Validator.notEmpty(value); } }
        });
    }

    componentDidMount() {
        document.body.className = 'vertical-layout vertical-menu 1-column menu-expanded blank-page blank-page';
        document.body.setAttribute('data-col', '1-column');

        var self = this;
        fetch(Config.get('apiUrlBase') + '/public/2fa/totp/setup', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ token: localStorage.getItem('token') }),
        }).then(function(response) {
            if (response.status === 200) {
                response.json().then(function(data) {
                    var uri = data.provisioningUri;
                    var secret = '';
                    try {
                        var url = new URL(uri);
                        secret = url.searchParams.get('secret') || '';
                    } catch(e) {
                        secret = '';
                    }
                    self.setState({
                        provisioningUri: uri,
                        manualSecret: secret,
                        recoveryCodes: data.recovery_codes || [],
                        loading: false,
                    });
                    QRCode.toDataURL(uri, { errorCorrectionLevel: 'H', margin: 1, width: 300 })
                        .then(function(url) { self.setState({ qrImageUrl: url }); })
                        .catch(function() { /* QR generation failed — manual entry still available */ });
                });
            } else {
                self.setState({ loading: false });
                swal("Error", "No se pudo iniciar la configuración TOTP.", "error");
            }
        }).catch(function() {
            self.setState({ loading: false });
            swal("Error", "Contacte al administrador.", "error");
        });
    }

    handleFormChange(event) {
        var formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy[event.target.name] = event.target.value;
        this.setState({ formData: formDataCopy, errors: [] });
    }

    handleConfirmSubmit(event) {
        event.preventDefault();
        this.setState({ loading: true, errors: [] });
        var self = this;
        fetch(Config.get('apiUrlBase') + '/public/2fa/totp/confirm-setup', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ code: this.state.formData.code, token: localStorage.getItem('token') }),
        }).then(function(response) {
            response.json().then(function(data) {
                if (response.status === 200) {
                    self.setState({ redirectTo: '/' });
                    window.location.reload();
                } else if (response.status === 400) {
                    swal("Atención", self.props.intl.formatMessage(backendStrings[data.error] ? backendStrings[data.error] : backendStrings['errors.default']), "warning");
                } else {
                    self.error();
                }
            }).catch(function() { self.error(); });
        }).catch(function() { self.error(); }).finally(function() { self.setState({ loading: false }); });
    }

    handleGoHome() { this.setState({ redirectTo: '/' }); }

    error() { swal("Error", "Contacte al administrador.", "error"); }

    renderStep1() {
        return (
            <React.Fragment>
                <h5 className="text-center font-weight-bold text-muted mb-2">
                    <FormattedMessage id="2fa.totp.setup.titulo" defaultMessage="Configurar Autenticación" />
                </h5>
                <p className="text-center text-muted mb-3" style={{fontSize:'13px'}}>
                    <FormattedMessage id="2fa.totp.setup.qr_instrucciones" defaultMessage="Escanee el código QR con su aplicación de autenticación (Google Authenticator, Authy, etc.)" />
                </p>

                {this.state.qrImageUrl && (
                    <div className="text-center mb-3">
                        <img src={this.state.qrImageUrl} alt="QR Code" style={{maxWidth: '200px'}} />
                    </div>
                )}

                {this.state.manualSecret && (
                    <div className="mb-3">
                        <p className="text-center text-muted" style={{fontSize:'12px'}}>
                            <FormattedMessage id="2fa.totp.setup.secreto_manual" defaultMessage="¿No puede escanear? Ingrese este código manualmente:" />
                        </p>
                        <div className="text-center">
                            <code style={{fontSize:'14px', letterSpacing:'2px', userSelect:'all'}}>{this.state.manualSecret}</code>
                        </div>
                    </div>
                )}

                <button
                    className="btn btn-primary btn-block shadow-sm mt-3"
                    style={{borderRadius: '8px', height:'42px', fontWeight: '500'}}
                    onClick={function() { this.setState({ step: 2 }); }.bind(this)}
                >
                    <FormattedMessage id="2fa.totp.setup.boton_siguiente" defaultMessage="Siguiente" />
                </button>
            </React.Fragment>
        );
    }

    renderStep2() {
        var codes = this.state.recoveryCodes;
        return (
            <React.Fragment>
                <h5 className="text-center font-weight-bold text-muted mb-2">
                    <FormattedMessage id="2fa.totp.setup.recovery_titulo" defaultMessage="Códigos de recuperación" />
                </h5>
                <div className="alert alert-warning" style={{fontSize:'12px'}}>
                    <FormattedMessage id="2fa.totp.setup.recovery_advertencia" defaultMessage="Guarde estos códigos en un lugar seguro. Cada código solo puede usarse una vez." />
                </div>

                <div className="row mb-3">
                    {codes.map(function(code, i) {
                        return (
                            <div key={i} className="col-6 mb-1">
                                <div className="border rounded p-1 text-center" style={{fontFamily:'monospace', fontSize:'13px', backgroundColor:'#f8f9fa'}}>
                                    {code}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="form-check mb-3">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        id="codesAck"
                        checked={this.state.codesAcknowledged}
                        onChange={function(e) { this.setState({ codesAcknowledged: e.target.checked }); }.bind(this)}
                    />
                    <label className="form-check-label text-muted" htmlFor="codesAck" style={{fontSize:'13px'}}>
                        <FormattedMessage id="2fa.totp.setup.recovery_checkbox" defaultMessage="He guardado mis códigos" />
                    </label>
                </div>

                <button
                    className="btn btn-primary btn-block shadow-sm"
                    style={{borderRadius: '8px', height:'42px', fontWeight: '500'}}
                    disabled={!this.state.codesAcknowledged}
                    onClick={function() { this.setState({ step: 3 }); }.bind(this)}
                >
                    <FormattedMessage id="2fa.totp.setup.boton_siguiente" defaultMessage="Siguiente" />
                </button>
            </React.Fragment>
        );
    }

    renderStep3() {
        this.formValidation.validate();
        var validationState = this.formValidation.state;
        return (
            <React.Fragment>
                <h5 className="text-center font-weight-bold text-muted mb-2">
                    <FormattedMessage id="2fa.totp.setup.confirmar_titulo" defaultMessage="Confirmar configuración" />
                </h5>
                <p className="text-center text-muted mb-3" style={{fontSize:'13px'}}>
                    <FormattedMessage id="2fa.totp.setup.confirmar_instrucciones" defaultMessage="Ingrese el código de 6 dígitos de su aplicación" />
                </p>
                <form className="form-horizontal" noValidate onSubmit={this.handleConfirmSubmit}>
                    <fieldset className="form-group position-relative has-icon-left mb-1">
                        <input
                            type="text"
                            className="form-control text-center"
                            style={{borderRadius: '8px', height:'45px', fontSize:'18px', letterSpacing:'2px'}}
                            name="code"
                            placeholder="000000"
                            maxLength={6}
                            required
                            onChange={this.handleFormChange}
                            value={this.state.formData.code}
                        />
                        <div className="form-control-position" style={{top:'3px'}}><i className="la la-key"></i></div>
                    </fieldset>
                    <button type="submit" className="btn btn-primary btn-block shadow-sm mt-3" style={{borderRadius: '8px', height:'42px', fontWeight: '500'}} disabled={!validationState.form.valid}>
                        <FormattedMessage id="2fa.totp.setup.confirmar_boton" defaultMessage="Confirmar" />
                    </button>
                </form>
            </React.Fragment>
        );
    }

    render() {
        if (!this.loginRandom) this.loginRandom = 1 + Math.floor((4 - 1) * Math.random());

        var logoAppSrc = this.getBrandedLogo("logo-login-app.png");
        var logoCompanySrc = this.getBrandedLogo("logo-login-company.png", "frontend.logos.company.visible");
        var logoPoweredBySrc = this.getBrandedLogo("logo-login-powered-by.png", "frontend.logos.poweredBy.visible");

        return (
            <React.Fragment>
                {this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
                {this.state.loading && <Loading hideSpinner />}
                <div className="app-content content">
                    <div className="content-wrapper">
                        <div className="content-body">
                            <video className="video-login-bg" autoPlay muted loop poster={process.env.PUBLIC_URL + "/images/images-login/image" + this.loginRandom + ".png"}>
                                <source src={process.env.PUBLIC_URL + "/images/videos-login/video" + this.loginRandom + ".mp4"} type="video/mp4" />
                            </video>
                            <section className="flexbox-container">
                                <div className="col-12 d-flex align-items-center justify-content-center">
                                    <div className="col-11 col-sm-8 col-md-6 col-lg-4 p-0" style={{maxWidth: '420px'}}>
                                        <div className="card border-0 m-0" style={{borderRadius: '1rem', boxShadow: '0 15px 35px rgba(0,0,0,0.2)'}}>

                                            <div className="card-header border-0 text-center pb-0" style={{paddingTop: '2rem'}}>
                                                <img src={logoAppSrc} alt="App Logo" className="img-fluid center-block" style={{ maxHeight: '90px', objectFit: 'contain' }} onError={function(e) { e.target.onerror=null; e.target.src="/images/company/logo-login-app.png"; }} />
                                            </div>

                                            <div className="card-body" style={{padding: '1.5rem 1.5rem 1rem'}}>
                                                {this.state.step === 1 && this.renderStep1()}
                                                {this.state.step === 2 && this.renderStep2()}
                                                {this.state.step === 3 && this.renderStep3()}

                                                <button type="button" className="btn btn-link btn-block mt-2 text-muted" onClick={this.handleGoHome.bind(this)}>
                                                    <FormattedMessage id="2fa.totp.setup.volver_inicio" defaultMessage="Volver al inicio" />
                                                </button>

                                                <div className="mt-3 pt-3" style={{borderTop: '1px solid #f3f3f3'}}>
                                                    <div className="row align-items-center">
                                                        <div className="col-6 text-left">{logoCompanySrc && <img src={logoCompanySrc} alt="Company" className="img-fluid" style={{maxHeight: '35px', maxWidth: '100%', objectFit:'contain'}} onError={function(e) { e.target.onerror=null; e.target.src="/images/company/logo-login-company.png"; }} />}</div>
                                                        <div className="col-6 text-right">{logoPoweredBySrc && <img src={logoPoweredBySrc} alt="Powered By" className="img-fluid" style={{maxHeight: '30px', maxWidth: '100%', objectFit:'contain'}} onError={function(e) { e.target.onerror=null; e.target.src="/images/company/logo-login-powered-by.png"; }} />}</div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default injectIntl(TwoFATotpSetup);
